module.exports={
  'empty': [
    {
      container: false,
    },
    {}
  ],
  'book': [
    {
      author: 'Copeland, Edward.',
      title: '“Money.”',
      container: false,
      images: {
        author: '/assets/images/citation-book-3.png',
        title: '/assets/images/citation-book-3.png'
      }
    },
    {
      title: '<em>The Cambridge Companion to Jane Austen</em>,',
      author: 'edited by Copeland and Juliet McMaster,',
      publisher: 'Cambridge UP,',
      pubdate: '1997,',
      location: 'pp. 131-48.',
      callouts: {
        version: 'For guidance on when to skip items in the template, see p. 20 of the <em>MLA Handbook</em>.'
      },
      images: {
        author: '/assets/images/citation-book-1.png',
        title: '/assets/images/citation-book-1.png',
        publisher: '/assets/images/citation-book-1.png',
        pubdate: '/assets/images/citation-book-2.png',
        location: '/assets/images/citation-book-3.png'
      }
    }
  ],
  'video': [
    {
      title: '“<em>Curiosity</em> Rover Report (August 2015): Three Years on Mars!”',
      container: false,
      callouts: {
        author: 'This source has no author. See pp. 24 and 55–56 of the <em>MLA Handbook</em> for more guidance.'
      },
      images: {
        title: '/assets/images/citation-video-1.png'
      }
    },
    {
      title: '<em>NASA’s Journey to Mars: Videos</em>,',
      author: 'edited by Sarah Loff,',
      publisher: 'National Aeronautics and Space Administration,',
      pubdate: '30 July 2015,',
      location: 'www.nasa.gov/topics/journeytomars/videos/index.html.',
      images: {
        author: '/assets/images/citation-video-1.png',
        title: '/assets/images/citation-video-1.png',
        publisher: '/assets/images/citation-video-1.png',
        pubdate: '/assets/images/citation-video-1.png',
        location: '/assets/images/citation-video-1.png',
      }
    }
  ],
  'journal': [
    {
      title: '“Between Image and Word, Color, and Time: Jacob Lawrence’s <em>The Migration Series</em>.”',
      author: 'Lorensen, Jutta.',
      container: false,
      images: {
        author: '/assets/images/citation-journal-1.png',
        title: '/assets/images/citation-journal-1.png'
      }
    },
    {
      title: '<em>African American Review</em>,',
      number: 'vol. 40, no. 3,',
      pubdate: '2006,',
      location: 'pp. 571-86.',
      images: {
        title: '/assets/images/citation-journal-1.png',
        number: '/assets/images/citation-journal-1.png',
        pubdate: '/assets/images/citation-journal-1.png',
        location: '/assets/images/citation-journal-1.png'
      }
    },
    {
      title: '<em>EBSCOHost</em>,',
      location: 'search.ebscohost.com/login.aspx?direct=true&db=f5h&AN=24093790&site=ehost-live.',
      callouts: {
        title: 'Learn where to find publication information for online sources and when to omit a publisher’s name on pp. 17 and 42 of the <em>MLA Handbook</em>.'
      },
      images: {
        title: '/assets/images/citation-journal-1.png',
        location: '/assets/images/citation-journal-1.png'
      }
    }
  ]
}
